import { Outlet } from 'react-router-dom'
import { Box } from '@mui/material'

interface AuthLayoutProps {
  children?: React.ReactNode
}

/**
 * AuthLayout — wrapper for auth pages (login, forgot password, etc.)
 * No sidebar or app header. Centered card layout.
 */
export const AuthLayout = ({ children }: AuthLayoutProps) => {
  return <Box sx={{ minHeight: '100vh' }}>{children ?? <Outlet />}</Box>
}
